import { render, staticRenderFns } from "./factures-en-attente.html?vue&type=template&id=3c0b6715&scoped=true&external"
import script from "./factures-en-attente.js?vue&type=script&lang=js&external"
export * from "./factures-en-attente.js?vue&type=script&lang=js&external"
import style0 from "./factures-en-attente.scss?vue&type=style&index=0&id=3c0b6715&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b6715",
  null
  
)

export default component.exports